<template>
  <div>
    <PageAllow controller="PurchasePlans" action="getPurchaseableDetails" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-card v-show="!preview">
        <v-card-title class="mx-3">
          {{ $t("PurchasePlans.title") }}
          <v-spacer />
          <v-btn
            v-if="$permission.permissionAllow('PurchasePlans', 'addViews')"
            small
            :disabled="!doPreviewFlg"
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="doPreview()"
          >
            <v-icon x-small class="pe-1">fa-save</v-icon>
            {{ $t("PurchasePlans.actions.previewSubmit") }}
          </v-btn>
        </v-card-title>
        <v-divider />
        <div v-for="(purchasePlan, index) in purchasePlans" :key="index">
          <v-data-table
            :headers="detailsHeaders"
            :items="purchasePlan.purchase_plan_details"
            disable-sort
            class="elevation-2 px-4 mt-4"
            disable-pagination
            hide-default-footer
            :no-data-text="$t('PurchasesList.intelligent.DetailNoData')"
            v-if="purchasePlan.purchase_plan_details.length"
          >
            <template v-slot:top>
              <v-toolbar flat class="transparent-background-color">
                <v-toolbar-title class="ms-n2">
                  {{ purchasePlan.stock.name }}
                </v-toolbar-title>
              </v-toolbar>
              <v-divider />
            </template>
            <!-- 规格 -->
            <template v-slot:item.standard_name="{ item }">
              <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
                <span v-else>
                {{ item.standard_name ? item.standard_name : "" }}
              </span>
            </template>
            <!-- 采购订货数 -->
            <template v-slot:item.quantity="{ item }">
              <v-text-field
                single-line
                dense
                hide-details
                v-model="item.quantity"
                type="number"
                min="0"
                @blur="
                  item.quantity = $numberFormatter.formatWithDotNoMoreThan(
                    Number(item.quantity),
                    2
                  );
                  $forceUpdate();
                "
                style="max-width: 100px; margin-left: auto"
              >
              </v-text-field>
            </template>
            <template v-slot:item.unit="{ item }">
              <v-autocomplete
                v-model="item.standard_detail_id"
                :items="item.standard_details"
                item-text="unit"
                item-value="id"
                unclearable
                style="width: 20px"
                @change="CalculateLoss(item.material_id)"
              />
            </template>
            <!-- 备注 -->
            <template v-slot:item.memo="{ item }">
              <v-text-field
                v-model="item.memo"
                single-line
                dense
                hide-details
                style="max-width: 200px"
              >
                <template v-slot:append>
                  <v-icon
                    x-small
                    @click.stop="
                      detail_memo_item = item;
                      memoDialog = true;
                    "
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-edit
                  </v-icon>
                </template>
              </v-text-field>
            </template>
            <!-- 操作 -->
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                text
                class="danger--text pa-0"
                @click.stop="
                  purchasePlan.purchase_plan_details.splice(
                    purchasePlan.purchase_plan_details.findIndex(
                      (e) => item.material_id == e.material_id
                    ),
                    1
                  )
                "
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>
            <template v-slot:footer>
              <v-divider />
              <v-row no-gutters class="pt-2 pb-4">
                <!-- <v-spacer /> -->
                <!-- 供应商 -->
                <v-col cols="12" md="4"> </v-col>
                <v-col cols="12" md="4"></v-col>
                <!-- 总计 -->
                <v-col cols="12" md="4">
                  <!--                  <v-list-item>-->
                  <!--                    <v-list-item-content>-->
                  <!--                      <span class="secondary&#45;&#45;text font-weight-bold">-->
                  <!--                        {{ $t("PurchasesList.intelligent.sum") }}-->
                  <!--                      </span>-->
                  <!--                    </v-list-item-content>-->
                  <!--                    <v-list-item-content>-->
                  <!--                      <span class="accent&#45;&#45;text font-weight-bold">-->
                  <!--                        {{ $t("Global.money")-->
                  <!--                        }}{{ purchasePlan.total_price | formatMoney }}-->
                  <!--                      </span>-->
                  <!--                    </v-list-item-content>-->
                  <!--                  </v-list-item>-->
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </div>
      </v-card>
      <v-card v-show="preview">
        <v-card-title class="mx-3">
          {{ $t("PurchasesList.intelligent.purchases") }}
          <v-spacer />
          <v-btn
            small
            outlined
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="preview = false"
          >
            {{ $t("PurchasePlans.actions.backBTN") }}
          </v-btn>
          <v-btn
            v-if="$permission.permissionAllow('PurchasePlans', 'add')"
            small
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="doSubmit()"
          >
            <v-icon x-small class="pe-1">fa-save</v-icon>
            {{ $t("PurchasePlans.actions.submit") }}
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-data-table
          :headers="detailsHeaders"
          :items="purchasePlan.purchase_plan_details"
          disable-sort
          class="elevation-2 px-4 mt-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('PurchasesList.intelligent.DetailNoData')"
          v-for="(purchasePlan, index) in purchasePlansPreview"
          :key="index"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2 pt-1">
                {{ $t("PurchasesList.intelligent.purchasesList", [index + 1]) }}

                <br />
                <span class="text-subtitle-2">
                  {{ purchasePlan.stock ? purchasePlan.stock.name : "" }}
                </span>
              </v-toolbar-title>
            </v-toolbar>
            <v-divider />
          </template>
          <!-- 商品名称 -->
          <template v-slot:item.material_name="{ item }">
            {{ item.material ? item.material.material_name : "" }}
          </template>
          <!-- 规格 -->
          <template v-slot:item.standard_name="{ item }">
            <span v-if="item.material && item.material.standard_name && item.material.standard_name.length > 12" :title="item.material.standard_name" style="cursor: pointer">
              {{ item.material.standard_name.slice(0, 12) + "......" }}
            </span>
            <span v-else>
              {{ item.material.standard_name ? item.material.standard_name : "" }}
              </span>
          </template>
          <!-- 采购订货数 -->
          <template v-slot:item.quantity="{ item }">
            {{ item.quantity | formatTwoDot }}
          </template>
          <template v-slot:item.unit="{ item }">
            {{ item.standard_detail ? item.standard_detail.unit : "" }}
          </template>
        </v-data-table>
      </v-card>
    </v-sheet>
    <v-dialog v-model="noPurchase" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("PurchasesList.intelligent.purchases") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="$router.push('/intelligent-purchase')"
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text
          class="px-4 py-8 text-center subtitle-1 red--text font-weight-bold"
        >
          {{ $t("PurchasesList.intelligent.noPurchase") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            outlined
            @click="$router.push('/intelligent-purchase')"
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn
            @click.stop="
              $router.push('/intelligent-purchase/purchase-from-order')
            "
            color="primary"
          >
            {{ $t("PurchasesList.intelligent.jump") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 备注弹窗 -->
    <v-dialog v-model="memoDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span class="d-inline-block text-center" style="max-width: 360px">
            {{ $t("financeBillEdit.memo") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memoDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
            v-model="detail_memo_item.memo"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memoDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import PurchasePlans from "@/api/purchase_plans";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.purchases"),
          disabled: false,
          href: "/purchases",
        },
        {
          text: i18n.t("Nav.purchasePlans"),
          disabled: false,
          href: "/purchase-plans",
        },
        {
          text: i18n.t("PurchasePlans.create.title"),
          disabled: true,
          href: "/purchase-plans/purchase-plans-create",
        },
      ];
    },
    detailsHeaders() {
      let headers = [
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.standard_name"),
          align: "start",
          sortable: false,
          value: "standard_name",
        },
        //   采购订货数
        {
          text: i18n.t("PurchasesDetail.purchaseFields.quantity"),
          align: "center",
          sortable: false,
          width: "150",
          value: "quantity",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        // 备注
        {
          text: i18n.t("PurchasesDetail.purchaseFields.memo"),
          align: "center",
          sortable: false,
          width: "200",
          value: "memo",
        },
      ];
      if (!this.preview) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          width: "100",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    locale() {
      return this.$i18n.locale != "zhHans";
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    purchasePlans: [],
    noPurchase: false,
    detail_memo_item: { memo: "" },
    memoDialog: false,
    doPreviewFlg: false,
    purchasePlansPreview: [],
    preview: false,
    is_loss: false,
  }),

  mounted() {
    this.getPurchaseableDetails();
  },

  methods: {
    getPurchaseableDetails() {
      let parameter = {};
      let parameterStr = sessionStorage.getItem(
        "purchase-plans-stock-outs-parameter"
      );
      if (
        typeof parameterStr != "undefined" &&
        parameterStr != null &&
        parameterStr != "null"
      ) {
        parameter = JSON.parse(parameterStr);
      }
      let data = {};
      data = Object.assign({}, parameter, {
        stock_order_ids: this.$route.query.ids,
      });
      if (this.$route.query.supplierId) {
        data = Object.assign({}, data, {
          purchase_plan_supplier_id: this.$route.query.supplierId,
        });
      }
      if (this.$route.query.materialIds) {
        data = Object.assign({}, data, {
          material_ids: this.$route.query.materialIds,
        });
      }
      PurchasePlans.getPurchaseableDetails(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.is_loss = response.data.is_loss;
            this.purchasePlans = response.data.purchase_plans;
            // if (this.is_loss) {
            //   this.purchasePlans.forEach((plan) => {
            //     if (plan.purchase_plan_details && plan.purchase_plan_details.length > 0) {
            //       plan.purchase_plan_details.forEach((detail) => {
            //         if (detail.loss_percent) {
            //           detail.quantity = this.$numberFormatter.formatTwoDot( Number(detail.purchase_num) + (Number(detail.purchase_num) * Number(detail.loss_percent) / 100))
            //         }
            //       })
            //     }
            //   })
            // }
            this.purchasePlans.forEach((p) => {
              p.purchase_plan_details.forEach((detail) => {
                if (this.is_loss) {
                  let standard_detail = detail.standard_details.find(
                    (d) => d.id == detail.standard_detail_id
                  );
                  if (standard_detail.loss_percent) {
                    detail.quantity = this.$numberFormatter.formatTwoDot(
                      Number(detail.purchase_num) +
                        (Number(detail.purchase_num) *
                          Number(standard_detail.loss_percent)) /
                          100
                    );
                  } else {
                    detail.quantity = parseFloat(
                      Number(detail.purchase_num).toFixed(2)
                    );
                  }
                } else {
                  detail.quantity = parseFloat(
                    Number(detail.purchase_num).toFixed(2)
                  );
                }
                detail = Object.assign(detail, {
                  standard_detail_id_before_change: detail.standard_detail_id, //用于单位切换的计算
                });
              });
            });
            this.doPreviewFlg = true;
            if (!this.purchasePlans.length) {
              this.noPurchase = true;
            }
          }
        }.bind(this)
      );
    },
    //整理预览提交数据
    doPreviewData() {
      let purchasePlans = [];
      this.purchasePlans.forEach((p) => {
        if (p.purchase_plan_details.length) {
          let purchasePlan = {
            stock_id: p.stock ? p.stock.id : null,
            purchase_plan_details: [],
          };
          p.purchase_plan_details.forEach((detail) => {
            purchasePlan.purchase_plan_details.push({
              material_code: detail.material_code,
              standard_detail_id: detail.standard_detail_id,
              quantity: detail.quantity ? detail.quantity : null,
              memo: detail.memo,
              out_detail_ids: detail.detail_ids ? detail.detail_ids : [],
            });
          });
          purchasePlans.push(purchasePlan);
        }
      });
      return purchasePlans;
    },
    //添加预览
    doPreview() {
      let data = this.doPreviewData();
      let dateNull = null;
      if (data.length) {
        data.forEach((p) => {
          if (p.purchase_plan_details == []) {
            dateNull += 1;
          }
        });
      }
      if (dateNull) {
        this.$snackbar.error(
          i18n.t("PurchasesDetail.Messages.expectDistributionDateNull")
        );
      } else if (!data.length) {
        this.$snackbar.error(i18n.t("PurchasesDetail.Messages.dataNull"));
      } else {
        PurchasePlans.addViews(data).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.preview = true;
              this.purchasePlansPreview = response.data.purchase_plans;
            }
          }.bind(this)
        );
      }
    },
    //整理预览提交数据
    doSubmitData() {
      let purchasePlans = this.purchasePlansPreview.map((p) => {
        let purchasePlan = {
          stock_id: p.stock.id,
          purchase_plan_details: [],
        };

        p.purchase_plan_details.forEach((detail) => {
          purchasePlan.purchase_plan_details.push({
            material_code: detail.material_code,
            out_detail_ids: detail.out_detail_ids ? detail.out_detail_ids : [],
            quantity: detail.quantity ? detail.quantity : null,
            standard_detail_id: detail.standard_detail_id,
            memo: detail.memo ? detail.memo : "",
          });
        });
        return purchasePlan;
      });
      return purchasePlans;
    },

    doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      PurchasePlans.add(this.doSubmitData())
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/purchase-plans");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    CalculateLoss(id) {
      this.purchasePlans.forEach((p) => {
        p.purchase_plan_details.forEach((detail) => {
          if (detail.material_id == id) {
            let standard_detail = detail.standard_details.find(
              (d) => d.id == detail.standard_detail_id
            );
            let standard_detail_before_change = detail.standard_details.find(
              (d) => d.id == detail.standard_detail_id_before_change
            );
            // 单位切换进行换算，向上取整
            detail.quantity =
              Math.ceil(
                detail.quantity *
                  (standard_detail_before_change.rate / standard_detail.rate) *
                  100
              ) / 100;
            detail.standard_detail_id_before_change = detail.standard_detail_id;
            if (this.is_loss) {
              // 计算损耗浮动百分比
              if (standard_detail.loss_percent) {
                detail.quantity = this.$numberFormatter.formatTwoDot(
                  Number(detail.quantity) +
                    (Number(detail.quantity) *
                      Number(standard_detail.loss_percent)) /
                      100
                );
              }
            }
          }
        });
      });
    },
  },

  watch: {
    // purchasePlans: {
    //   deep: true,
    //   handler() {
    //     // 计算损耗浮动百分比
    //     this.purchasePlans.forEach((p) => {
    //       p.purchase_plan_details.forEach((detail) => {
    //         if (this.is_loss) {
    //           let standard_detail = detail.standard_details.find(
    //             (d) => d.id == detail.standard_detail_id
    //           );
    //           if (standard_detail.loss_percent) {
    //             detail.quantity = this.$numberFormatter.formatTwoDot(
    //               Number(detail.purchase_num) +
    //                 (Number(detail.purchase_num) *
    //                   Number(standard_detail.loss_percent)) /
    //                   100
    //             );
    //           } else {
    //             detail.quantity = parseFloat(
    //               Number(detail.purchase_num).toFixed(2)
    //             );
    //           }
    //         } else {
    //           detail.quantity = parseFloat(
    //             Number(detail.purchase_num).toFixed(2)
    //           );
    //         }
    //       });
    //     });
    //   },
    // },
  },
};
</script>